/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import {
  ExpandMoreRounded,
  Search,
} from '@mui/icons-material';
import {
  Box,
  Chip, Container, Divider, Grid, MenuItem, Pagination, Select, Skeleton, Tab, Tabs, TextField,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker, { DateObject, getAllDatesInRange } from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';
import Colors from '../../../../Configs/colors';
import Images from '../../../../Configs/images';
import Elements from '../../../Elements';
import { downloadRequestReport, getAdminRequests } from '../../../../Redux/Models/request';
import ROUTES from '../../../../Configs/routes';
import { getDashboardInfo } from '../../../../Redux/Models/dashboard';
import { getRequestStatus } from '../../../../Redux/Models/master';
import AlertContext from '../../../../Context/AlertContext';

export default function Home({
  classes, isLoading, data, currentPage, totalPage, totalData,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datePickerRef = useRef(null);
  const [reqStatus, setStatus] = useState('all');
  const { openAlert } = useContext(AlertContext);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [type, setType] = useState('all');
  const [sort, setSort] = useState('Newest');

  const [rangeDate, setRangeDate] = useState([
    new DateObject().subtract(30, 'days'),
    new DateObject(),
  ]);

  const { requestStatus } = useSelector((state) => state.master);

  useEffect(() => {
    dispatch(getDashboardInfo());
    dispatch(getRequestStatus());
  }, []);

  useEffect(() => {
    dispatch(getAdminRequests({
      page,
      limit,
      type: type === 'all' ? '' : type,
      status: reqStatus === 'all' ? '' : reqStatus,
      sort,
    }));
  }, [reqStatus, page, limit, type, sort]);

  const chipLabelStyle = {
    '& .MuiChip-label': {
      fontSize: 10,
      fontWeight: '700',
      color: Colors.primary,
      fontFamily: 'Nunito Sans',
    },
    background: '#FDE0E0',
    padding: '0px 1px',
  };

  const downloadReport = () => {
    if (rangeDate.length === 2) {
      const body = {
        startDate: rangeDate[0].toDate().toISOString(),
        endDate: rangeDate[1].toDate().toISOString(),
        type: type === 'all' ? '' : type,
      };
      dispatch(downloadRequestReport(body));
    } else {
      openAlert({
        severity: 'warning',
        title: 'Date range not completed',
        message: 'Please complete date range first!',
      });
    }
  };

  const renderRequests = () => {
    if (isLoading) {
      return (
        <Box className="request-card" mt={2}>
          <div>
            <Skeleton variant="rectangular" width={100} height={24} sx={{ borderRadius: 2 }} />
            <div className="flex space-between mt-2 align-items-center">
              <Skeleton variant="rectangular" width={80} height={18} sx={{ borderRadius: 2 }} />
              <Skeleton width={40} variant="text" />
            </div>
            <Skeleton width={100} variant="text" />
            <Skeleton width="100%" variant="text" />
            <div className="flex space-between">
              <Skeleton width={10} variant="text" />
              <Skeleton width={80} variant="text" />
            </div>
          </div>
        </Box>
      );
    }
    if (data?.length) {
      return data.map((req) => (
        <Box
          borderRadius="10px"
          border="2px solid"
          borderColor={req.status === 'Requested' ? '#B4112E' : '#E5E5E5'}
          boxSizing="border-box"
          overflow="hidden"
          mt={2}
          key={req.id}
          onClick={() => navigate(`${req.type === 'Request Out' ? ROUTES.requestOut() : ROUTES.requestIn()}/${req.id}`)}
        >
          <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={2}>
            <Box display="flex" alignItems="center" gap={1.5}>
              <Box display="flex" alignItems="center" gap={1}>
                <img src={req.type === 'Request In' ? Images.OenoIn : Images.OenoOut} alt="type" width="20" height="20" />
                <div className="weight-700 s-12 primary-green">
                  {req.type}
                </div>
              </Box>
              <Box height={4} width={4} bgcolor="#ABB1BB" className="circle" />
              <Box className="weight-700 s-12" color="RI1234">
                {req.id}
              </Box>
              {req.status === 'Requested'
              && (
              <>
                <Box height={4} width={4} bgcolor="#ABB1BB" className="circle" />
                <div className="weight-700 s-12 primary-green">
                  New Request Order
                </div>
              </>
              )}
            </Box>
            <Box bgcolor="#D9EDFC" fontSize={12} fontWeight="700" color="#2391D9" py="2px" px={1} borderRadius="4px">{req.status}</Box>
          </Box>
          <Box bgcolor="#FDFDFD" py={2} px={2}>
            <Box display="flex" gap={2}>
              <Box flex={1}>
                <Box
                  display="flex"
                  gap={0.5}
                  mt={1}
                  alignItems="center"
                >
                  <img alt="delivery" src={req.delivery_type?.icon === 'warehouse' ? Images.IconHome : Images.IconDelivery} />
                  <Box fontWeight="700" fontSize={12}>{req.delivery_type?.name}</Box>
                </Box>
                <Box mt={2}>
                  <Box className="mute" fontSize={10}>Scheduled On</Box>
                  <Box mt={0.5} fontSize={12} fontWeight="700">{moment(req.request_date).format('DD MMM YYYY, HH.mm')}</Box>
                </Box>
                {!!req.stored_in_warehouse_at
                && (
                <Box mt={2}>
                  <Box className="mute" fontSize={10}>Stored in Warehouse</Box>
                  <Box mt={0.5} fontSize={12} fontWeight="700">{moment(req.stored_in_warehouse_at).format('DD MMM YYYY, HH.mm')}</Box>
                </Box>
                )}
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box flex={2}>
                <Box fontSize={12} fontWeight="700">Customer Information</Box>
                <Box display="flex">
                  <Box flex={1}>
                    <Box mt={1}>
                      <Box className="mute" fontSize={10}>Customer Name</Box>
                      <Box mt={0.5} fontSize={12} fontWeight="700">{req.delivery_address?.name}</Box>
                    </Box>
                    <Box mt={1}>
                      <Box className="mute" fontSize={10}>Items</Box>
                      <Box mt={0.5} fontSize={12} fontWeight="700">
                        {req.box?.amount || req.amount}
                        {' '}
                        {req.box?.amount > 1 || req.amount > 1 ? 'Items' : 'Item'}
                        {' '}
                        {req.box ? '(Box)' : ''}
                      </Box>
                    </Box>
                    <Box mt={1}>
                      <Box className="mute" fontSize={10}>Paid Status</Box>
                      <Box mt={0.5} fontSize={12} fontWeight="700">{req.paid_status || '-'}</Box>
                    </Box>
                  </Box>
                  <Box flex={1}>
                    <Box mt={1}>
                      <Box className="mute" fontSize={10}>Delivery Address</Box>
                      <Box mt={0.5} fontSize={12} fontWeight="700">
                        {req.delivery_address?.address}
                        ,
                        {' '}
                        {req.delivery_address?.city}
                        ,
                        {' '}
                        {req.delivery_address?.province}
                        ,
                        {' '}
                        {req.delivery_address?.country}
                        ,
                        {' '}
                        {req.delivery_address?.postal_code}
                      </Box>
                    </Box>
                    <Box mt={1}>
                      <Box className="mute" fontSize={10}>Phone Number</Box>
                      <Box mt={0.5} fontSize={12} fontWeight="700">{req.delivery_address?.phone_number}</Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem />
              <Box flex={1}>
                <Box fontSize={12} fontWeight="700">Courier Information</Box>
                <Box mt={1}>
                  <Box className="mute" fontSize={10}>Name</Box>
                  <Box mt={0.5} fontSize={12} fontWeight="700">{req.courier_name || '-'}</Box>
                </Box>
                <Box mt={1}>
                  <Box className="mute" fontSize={10}>Phone Number</Box>
                  <Box mt={0.5} fontSize={12} fontWeight="700">{req.courier_phone_number || '-'}</Box>
                </Box>
              </Box>
            </Box>
            <Divider sx={{ my: 2 }} />
            <Box textAlign="right">
              <Link className="link primary-green s-12 weight-700" to={`${req.type === 'Request Out' ? ROUTES.requestOut() : ROUTES.requestIn()}/${req.id}`}>See detail</Link>
            </Box>
          </Box>
        </Box>
      ));
    }
    return null;
  };

  return (
    <Elements.AdminPageBase
      navigate={navigate}
    >
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box color="#404852" fontWeight="700" fontSize={18}>Request Order</Box>
          <Box display="flex" alignItems="center">
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              py={1}
              px={2}
              bgcolor="#FDFDFD"
              borderRadius="10px"
              border="1px solid #E5E5E5"
              className="link"
              fontSize={14}
              onClick={downloadReport}
            >
              <img src={Images.Download} alt="download" height="20" width="20" />
              Download Order Report
            </Box>
            <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 2 }} />
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              py={1}
              px={2}
              bgcolor="#FDFDFD"
              borderRadius="10px"
              border="1px solid #E5E5E5"
              className="link"
              fontSize={14}
            >
              <img src={Images.Calendar} alt="date" height="20" width="18" />
              <DatePicker
                range
                className="force-font-family"
                format="DD MMM YYYY"
                style={{
                  border: 'none',
                  fontSize: 14,
                  padding: 0,
                  margin: 0,
                  outline: 'none',
                }}
                value={rangeDate}
                onChange={setRangeDate}
                rangeHover
                dateSeparator=" - "
              />
            </Box>
          </Box>
        </Box>

        <Box bgcolor="#FDFDFD" borderRadius="10px" pb={1} px={1} mt={2}>
          <Tabs value={type} className={`${classes.tabs}`} onChange={(e, newType) => setType(newType)}>
            <Tab
              label={(
                <Box display="flex" gap={1.5} alignItems="center">
                  All Request
                  {/* <Chip label={requests.length} sx={chipLabelStyle} size="small" /> */}
                </Box>
              )}
              value="all"
              disableRipple
            />
            <Tab
              label={(
                <Box display="flex" gap={1.5} alignItems="center">
                  Request In
                  {/* <Chip label={requests.length} sx={chipLabelStyle} size="small" /> */}
                </Box>
              )}
              value="Request In"
              disableRipple
            />
            <Tab
              label={(
                <Box display="flex" gap={1.5} alignItems="center">
                  Request Out
                  {/* <Chip label={requests.length} sx={chipLabelStyle} size="small" /> */}
                </Box>
              )}
              value="Request Out"
              disableRipple
            />
          </Tabs>
        </Box>

        <Box mt={2} className="flex gap-16 space-between">
          <Box display="flex" gap={1}>
            <Select
              select
              size="small"
              value={sort}
              onChange={({ target }) => setSort(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="Oldest">Oldest</MenuItem>
              <MenuItem value="Newest">Newest</MenuItem>
            </Select>
            <Select
              select
              value={reqStatus}
              size="small"
              onChange={({ target }) => setStatus(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value="all">All status</MenuItem>
              {requestStatus.map((s) => (
                <MenuItem value={s} key={s}>{s}</MenuItem>
              ))}
            </Select>
          </Box>
          <Box display="flex" gap={2}>
            <Select
              select
              size="small"
              value={limit}
              onChange={({ target }) => setLimit(target.value)}
              IconComponent={ExpandMoreRounded}
              sx={{
                borderRadius: '10px',
                bgcolor: '#fff',
              }}
            >
              <MenuItem value={10}>10 List</MenuItem>
              <MenuItem value={20}>20 List</MenuItem>
              <MenuItem value={50}>50 List</MenuItem>
            </Select>
            <TextField
              placeholder="Search by keyword"
              size="small"
              sx={{
                ' .MuiInputBase-root': {
                  bgcolor: '#fff',
                },
              }}
              InputProps={{
                startAdornment: (<Search fontSize="small" sx={{ mr: 1, color: '#D4D4D4' }} />),
              }}
            />
          </Box>
        </Box>

        <Box display="flex" justifyContent="space-between" mt={2}>
          <Box fontSize={12} color="#586479">
            <strong>{totalData}</strong>
            {' '}
            total request order
          </Box>
          <Pagination
            count={totalPage}
            variant="outlined"
            shape="rounded"
            size="small"
            page={!isLoading ? currentPage : page}
            siblingCount={0}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </Box>

        {renderRequests()}

      </div>

    </Elements.AdminPageBase>
  );
}
